import React, { useState, useEffect, useCallback } from "react";

export interface TimerProps {
  timesOutInSeconds: number;
  onFinished: () => void;
  children: (secondsRemaining: number) => React.ReactNode;
}

export default function Timer({
  timesOutInSeconds,
  onFinished,
  children,
}: TimerProps) {
  const [secondsRemaining, setSecondsRemaining] = useState(timesOutInSeconds);

  const tick = useCallback(() => {
    setSecondsRemaining((prev) => {
      if (prev <= 1) {
        onFinished();
        return 0;
      }
      return prev - 1;
    });
  }, [onFinished]);

  useEffect(() => {
    if (secondsRemaining <= 0) {
      return;
    }

    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [secondsRemaining, tick]);

  return <>{children(secondsRemaining)}</>;
}
